module.exports = __webpack_public_path__ + "img/Romantikk_Bildekunsten_og_musikken5.47e1b0c4.jpg";